
import { businessUtils } from '@/context/utils/businessUtils'; // Replaced useDataUtils
import { BusinessFormData } from '../types';

export const useFormSave = (
  businessId: string | undefined, 
  formData: BusinessFormData, 
  formChanged: boolean
) => {
  // Save business details to global context
  const handleSave = () => {
    if (businessId) {
      // For backwards compatibility, maintain both old and new field names
      const updatedData = {
        // Business info
        name: formData.name,
        title: formData.name, // Update title field too for compatibility
        displayName: formData.displayName,
        shortName: formData.displayName, // Update shortName field too for compatibility
        primaryPhone: formData.primaryPhone,
        phone: formData.primaryPhone, // Update phone field too for compatibility
        primaryEmail: formData.primaryEmail,
        email: formData.primaryEmail, // Update email field too for compatibility
        websiteUrl: formData.websiteUrl,
        website: formData.websiteUrl, // Update website field too for compatibility
        openingDate: formData.openingDate,
        founded: formData.openingDate, // Update founded field too for compatibility
        
        // Address info
        address: formData.address,
        cityName: formData.cityName,
        city: formData.cityName, // Update city field too for compatibility
        stateCode: formData.stateCode,
        state: formData.stateCode, // Update state field too for compatibility
        postalCode: formData.postalCode,
        zip: formData.postalCode, // Update zip field too for compatibility
        
        // Other info
        timeZone: formData.timeZone,
        industry: formData.industry
      };
      
      businessUtils.updateBusiness(businessId, updatedData);
      return true;
    }
    return false;
  };

  return { handleSave };
};
